<div class="race-section" *ngIf="data && isHorizon">
    <a href="javascript:void(0)" routerLink="/event/detail/{{item?.event_id}}" class="chip" *ngFor="let item of data;trackBy:trackByIndex;">
        <img src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png" alt="Horse">
        <div class="race_detail">
          <span class="race_time">
            {{item?.market_start_time_format | date: 'hh:mm a'}}
          </span>
          <span class="race-name">{{item?.market_name}}</span>
        </div>
    </a>
</div>
<div class="race-section" *ngIf="data && !isHorizon">
    <tabset type="pills navtab-bg desktop-nav-pills">
      <tab [heading]="item?.event_country_code" *ngFor="let item of data;trackBy:trackByIndex;">
        <div class="bet-table position-relative horse-table" >
          <div class="bet-table-body">
              <div class="bet-table-row" *ngFor="let rc of item?.data;trackBy:trackByIndex;">
                  <div class="bet-nation-name">
                      <div class="game-icon"><i class="mdi mdi-television icon-tv"></i></div>
                      <div class="bet-nation-game-name"><span>{{rc?.event_name}}</span></div>
                  </div>
                  <div class="horse-time-detail" >
                      <a *ngFor="let race of rc?.data;trackBy:trackByIndex;" href="javascript:void(0);" [routerLink]="['/race/detail', race?.event_id, race?.market_id]"><span class="">{{race?.market_start_time_format | date : 'hh:mm'}}</span></a>
                  </div>
              </div>
          </div>
      </div>

      </tab>
    </tabset>
</div>

<div *ngIf="data && data.length == 0">No data found</div>